module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "$player",
    staticClass: "player"
  }, [_c('video', {
    ref: "$video",
    attrs: {
      "id": "video",
      "controls": false,
      "width": "100%",
      "height": "100%",
      "src": _vm.src
    },
    on: {
      "play": _vm.onPlay,
      "loadstart": _vm.onLoadstart,
      "canplay": _vm.onCanplay,
      "pause": _vm.onPause,
      "ended": _vm.onEnded,
      "error": _vm.onError,
      "timeupdate": _vm.onTimeupdate
    }
  }, [_vm._v("\n\t\t您的浏览器不支持 video 标签。\n\t")]), _vm._v(" "), _c('div', {
    staticClass: "player__mask",
    on: {
      "mousemove": _vm.showControls,
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.changePlayStatus($event)
      },
      "dblclick": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.fullScreen($event)
      }
    }
  }, [_c('div', {
    staticClass: "controls",
    class: {
      'controls--show': _vm.isShowControls || !_vm.playStatus
    }
  }, [_c('div', {
    staticClass: "controls-box"
  }, [_c('div', {
    staticClass: "controls-item"
  }, [_c('div', {
    staticClass: "controls-item__button",
    on: {
      "click": _vm.changePlayStatus
    }
  }, [_c('i', {
    staticClass: "iconfont",
    class: {
      'icon-video-play': !_vm.playStatus, 'icon-video-pause': _vm.playStatus
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "controls-item"
  }, [_vm._v(_vm._s(_vm._f("secondsFormat")(_vm.currentTime)) + " / " + _vm._s(_vm._f("secondsFormat")(_vm.totalTime)))])]), _vm._v(" "), _c('div', {
    staticClass: "controls-box"
  }, [_c('div', {
    staticClass: "controls-item"
  }, [_c('div', {
    staticClass: "controls-item__button",
    on: {
      "click": _vm.valumeMute
    }
  }, [_c('i', {
    staticClass: "iconfont",
    class: {
      'icon-video-volume': !_vm.isMute, 'icon-video-mute': _vm.isMute
    }
  })]), _vm._v(" "), _c('div', {
    ref: "$volumeProgress",
    staticClass: "controls-item__progress",
    on: {
      "click": function($event) {
        _vm.valumeSelect($event)
      }
    }
  }, [_c('div', {
    staticClass: "progress__bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "progress__play",
    style: ({
      width: _vm.volume + '%'
    })
  }, [_c('div', {
    staticClass: "progress__circle",
    on: {
      "mousedown": function($event) {
        $event.preventDefault();
        _vm.volumeDown($event)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "controls-item"
  }, [_c('div', {
    staticClass: "controls-item__button",
    on: {
      "click": _vm.fullScreen
    }
  }, [_c('i', {
    staticClass: "iconfont icon-video-fullscreen"
  })])])]), _vm._v(" "), _c('div', {
    ref: "$progress",
    staticClass: "player__progress",
    on: {
      "click": function($event) {
        _vm.onSelect($event)
      }
    }
  }, [_c('div', {
    staticClass: "progress__bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "progress__load",
    style: ({
      width: _vm.loadPercent + '%'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "progress__play",
    style: ({
      width: _vm.percent + '%'
    })
  }, [_c('div', {
    staticClass: "progress__circle",
    on: {
      "mousedown": function($event) {
        $event.preventDefault();
        _vm.onButtonDown($event)
      }
    }
  })])])])]), _vm._v(" "), (_vm.src !== null && !_vm.playStatus && !_vm.err) ? _c('img', {
    staticClass: "player__logo",
    attrs: {
      "src": require("./play.png"),
      "alt": "点击播放"
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.changePlayStatus($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.src || _vm.err) ? _c('div', {
    staticClass: "player__err"
  }, [_vm._t("err", [_c('p', {
    staticClass: "err"
  }, [_vm._v("播放源出问题啦  (╯￣Д￣)╯╘═╛")])])], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-2a8b4d5c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/player/vue-player.vue
// module id = 11
// module chunks = 0